Hop.defineModule('country-launching-banner', function (root) {
    const COOKIE_NAME = 'country-launching-banner';
    const closeBtn = root.querySelector('.js-close-btn');

    function hideBanner() {
        root.hidden = true;
        document.body.classList.remove('country-launching-banner__body');
    }

    function closeBannerOnClick() {
        hideBanner();
        Hop.setCookie(COOKIE_NAME, 'seen');
    }

    function initEventListener() {
        closeBtn.addEventListener('click', closeBannerOnClick);
    }

    initEventListener();

    return function destroy() {
        closeBtn.removeEventListener('click', closeBannerOnClick);
    };
});
